import { Chip, ListItemButton, Stack, Tooltip, Typography } from "@compass/core";
import { DataModelEnum } from "generated/openApi";
import { NavLayoutContext } from "layouts";
import "moment-timezone";
import { useContext, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { utilityMenuItems } from "./menuItems";
import { setAppNavDrawerOpen } from "redux/reducers/appSlice";
import { useDispatch } from "react-redux";

export const utilityLayoutRoutePath = "utility";

export const UtilityLayout = () => {
  const context = useContext(NavLayoutContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const menuItems = utilityMenuItems.sort((a, b) => a.handle.localeCompare(b.handle));
  const [manuallyOrderedDataModelEnums, setManuallyOrderedDataModelEnums] = useState<DataModelEnum[]>([]);

  useEffect(() => {
    context.setSubBar?.(getMenu());

    return () => {
      context.setSubBar?.(null);
    };
  }, [pathname, manuallyOrderedDataModelEnums]);

  useEffect(() => {
    const dataModelEnums = menuItems.filter((x) => x.orderable).map((x) => x.dataModelEnum);
    ApiService.common.usingDisplayOrderBulk(dataModelEnums).then((response) => {
      setManuallyOrderedDataModelEnums(response);
    });
  }, []);

  const getMenu = () => {
    return (
      <Stack>
        {/* <pre>{manuallyOrderedDataModelEnums}</pre> */}

        {menuItems.map((menuItem, index) => {
          const path = `/${utilityLayoutRoutePath}/${menuItem.getPath()}`;
          const manuallyOrdered = manuallyOrderedDataModelEnums.includes(menuItem.dataModelEnum);

          return (
            <ListItemButton
              key={index}
              sx={{ pl: 1.5, pr: 0.5 }}
              onClick={() => {
                navigate(path);
                dispatch(setAppNavDrawerOpen(false));
              }}
              selected={pathname.includes(path)}
            >
              <Stack width="100%" direction="row" alignItems="center" justifyContent="space-between">
                <Typography variant="subtitle2">{menuItem.handle}</Typography>

                {menuItem.orderable && (
                  <Tooltip
                    title={
                      <Stack>
                        <Typography variant="inherit">
                          {menuItem.handle} can be ordered manually or alphanumerically.
                        </Typography>
                        {manuallyOrdered && (
                          <Typography variant="inherit">
                            It is currently <b>manually</b> ordered.
                          </Typography>
                        )}
                        {!manuallyOrdered && (
                          <Typography variant="inherit">
                            It is currently <b>alphanumerically</b> ordered.
                          </Typography>
                        )}
                      </Stack>
                    }
                  >
                    <Stack direction="row">
                      <Chip label="A" size="xsmall" color="success" rectangular disabled={manuallyOrdered} />
                      <Chip label="M" size="xsmall" color="secondary" rectangular disabled={!manuallyOrdered} />
                    </Stack>
                  </Tooltip>
                )}
              </Stack>
            </ListItemButton>
          );
        })}

        {/* <Link to={utilityLayoutRoutePath + contributorMatchServiceListPageRoute.getPath()}></Link> */}
      </Stack>
    );
  };

  return <Outlet />;
};
